<template>
  <v-footer fixed padless class="font-weight-medium footer-wrap">
    <div class="d-flex flex-wrap justify-space-between footer-content-wrap mx-auto">
      <div class="footer-left d-flex align-center">
        <span class="footer-item">© 2020 - {{currYear}} GRXTrade, Inc. All Rights Reserved</span>
      </div>
    </div>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Footer',
  data() {
    return {
      currYear: new Date().getFullYear()
    }
  }
};
</script>

<style lang="stylus" scoped>
.v-footer {
  &.footer-wrap {
    background-color: #000000;
    color: #999;
    height: 47px;
    position: absolute;

    .footer-content-wrap {
      max-width: 1200px;
      width: 100%;
    }
  }
  .footer-item {
    font-size: 12px;
    margin-right: 15px;
    margin-left: 15px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .cursor {
    cursor: pointer;
  }
  .separator-dot {
    font-size: 8px;
  }
}
</style>
